import { StreamResolutionUtil } from '../../utility/StreamResolutionUtil';
import { StreamType } from '../../../api/models/Shared.types';
import { timeStringToMs } from '../../utility/DateFormatter';
import {
  IBundlePriceResponse3,
  IBundleResolutionResponse,
  IBundleResponse,
  IResolutionPriceResponse3,
  IValidQuotePriceResponse3,
} from '../../../api/models/AndromeTV.types';

export class BundleAsset {
  bundle: IBundleResponse;
  private quotes: IValidQuotePriceResponse3[];
  private price: IBundlePriceResponse3;
  private ottPricingResolutions: IResolutionPriceResponse3[];
  rentableBundleResolutions: IResolutionPriceResponse3[] | undefined;
  constructor(bundle: IBundleResponse, quotes: IValidQuotePriceResponse3[], price: IBundlePriceResponse3) {
    this.bundle = bundle;
    this.quotes = quotes;
    this.price = price;
    this.ottPricingResolutions = price && price.resolutions ? price.resolutions : [];
    this.calculateRentableBundleResolutions();
  }

  updateFromQuotes(quotes: IValidQuotePriceResponse3[]) {
    this.quotes = quotes;
    this.calculateRentableBundleResolutions();
  }

  calculateRentableBundleResolutions() {
    if (!this.bundle.resolutions) return;

    let highestWatchableResolution: IResolutionPriceResponse3;
    this.ottPricingResolutions.forEach(res => {
      if (
        this.quotes.some(quote => quote.entryId === this.bundle.id && quote.assetId === res.resolutionId) &&
        (!highestWatchableResolution ||
          StreamResolutionUtil.toInt(res.resolution) >
            StreamResolutionUtil.toInt(highestWatchableResolution.resolution))
      ) {
        highestWatchableResolution = res;
      }
    });

    // Get all the resolutions that are higher than the highest rented
    this.rentableBundleResolutions = this.ottPricingResolutions.filter(
      res =>
        res.type === StreamType.TVOD &&
        !this.quotes.some(quote => quote.entryId === this.bundle.id && quote.assetId === res.resolutionId) &&
        (!highestWatchableResolution ||
          StreamResolutionUtil.toInt(res.resolution) >
            StreamResolutionUtil.toInt(highestWatchableResolution.resolution))
    );

    this.rentableBundleResolutions.sort(StreamResolutionUtil.sortCompare);
  }

  hasSvodResolution(): boolean {
    return this.ottPricingResolutions.some(resolution => resolution.type === StreamType.SVOD);
  }

  hasFvodResolution(): boolean {
    return this.ottPricingResolutions.some(resolution => resolution.type === StreamType.FVOD);
  }

  streamsLeftToRent() {
    return this.rentableBundleResolutions && this.rentableBundleResolutions.length > 0;
  }

  bundleIsExpired() {
    const now = new Date().getTime();
    const start = timeStringToMs(this.bundle.validFrom);
    const end = timeStringToMs(this.bundle.validUntil);

    return start > now || end < now;
  }

  getAllResolutions(): IBundleResolutionResponse[] {
    const allResolutions: IBundleResolutionResponse[] = [];

    this.ottPricingResolutions.forEach(item =>
      allResolutions.push({ id: item.resolutionId, resolution: item.resolution })
    );

    return allResolutions;
  }

  getLastValidQuote() {
    let latestValidQuote: IValidQuotePriceResponse3 | undefined;
    this.quotes.forEach(quote => {
      if (!latestValidQuote || parseInt(quote.endTime, 10) > parseInt(latestValidQuote.endTime, 10)) {
        latestValidQuote = quote;
      }
    });

    return latestValidQuote;
  }

  // getPricingInfo(config) {
  //   const pricing = [];
  //   this.rentableBundleResolutions.forEach((stream) => {
  //     const priceString = formatQualityStringForPriceAndResolution(
  //       stream.price,
  //       stream.resolution.toUpperCase(),
  //       config
  //     );
  //     if (priceString) {
  //       pricing.push(priceString);
  //     }
  //   });
  //
  //   if (pricing) {
  //     return pricing.join('&nbsp;&nbsp;&nbsp;•&nbsp;&nbsp;&nbsp;');
  //   }
  //   return '';
  // }
}
